import qs from 'qs';
import { network } from 'services/network';

export const setPrivacyMode = ({ viewId, isPublic }: QueryParams) => {
    const querystring = qs.stringify({ viewId, isPublic }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/setPrivacyMode${querystring}`;
    return network.post(url).then((response) => response.data);
};

export interface QueryParams {
    viewId: number;
    isPublic: boolean;
}
